// export const BASE_URL = "https://dummy.restapiexample.com/api/v1/";
const BASE_URL: string = (process.env.REACT_APP_BASE_URL as string);



// Add or replace routes
export const API_ROUTES: { [key: string]: string } = {
  // Bartender
  bartenders: `${BASE_URL}bartenders`,
  getSingleBartender: `${BASE_URL}bartenders`,
  businessAdmin: `${BASE_URL}bartenders/businessadmin`,
  bartenderAvatar: `${BASE_URL}bartenders/avatar`,
  bartenderSchedule: `${BASE_URL}bartenders/scheduler`,
  toggleUserActive: `${BASE_URL}users/active`,
  packages: `${BASE_URL}packages`,
  singlePackageApi: `${BASE_URL}packages/packageid`,
  packageGarnishes: `${BASE_URL}garnish`,
  bartenderOneDaySchedule: `${BASE_URL}bartenders/adhoc`,
  getBartenderOneDaySchedule: `${BASE_URL}bartenders/adhoc`,
  deleteBartenderOneDaySchedule: `${BASE_URL}bartenders/adhoc`,
  bartenderBlockedDate: `${BASE_URL}bartenders/blocks`,
  allBartenders: `${BASE_URL}bartenders/list`,
  discounts: `${BASE_URL}discounts`,
  signin: `${BASE_URL}users/login`,
  signup: `${BASE_URL}users/register`,
  changePassword: `${BASE_URL}users/changepassword`,
  forgotPassword: `${BASE_URL}users/forgetPassword`,
  resetPasswordRoute: `${BASE_URL}users/reset-password`,
  newpasswordRoute: `${BASE_URL}resetPassword`,
  checkForgetToken: `${BASE_URL}users/expiry`,
  addCompanyApi: `${BASE_URL}business`,
  getCompanyApi: `${BASE_URL}business/getbusiness`,
  getActiveCompanyApi: `${BASE_URL}business/getactivebusinesslist`,
  editCompanyApi: `${BASE_URL}business`,
  addPackageApi: `${BASE_URL}packages`,
  packageToggle: `${BASE_URL}packages/togglestatus`,
  getAllBusinesses: `${BASE_URL}business/getbusinesslist`,
  toggleBusinessStatus: `${BASE_URL}business/togglestatus`,
  toggleBusinessOptionStatus: `${BASE_URL}business/application-access`,
  uploadImageApi: `${BASE_URL}uploads`,
  products: `${BASE_URL}products`,
  cocktail: `${BASE_URL}cocktails/businesscocktails`,
  createCocktail: `${BASE_URL}cocktails/createcocktail`,
  toggleCocktailApi: `${BASE_URL}cocktails/togglestatus`,
  getSingleCocktail: `${BASE_URL}cocktails/cocktailid`,
  getAllCocktaillist: `${BASE_URL}cocktails/allcocktails`,
  // Events
  getPastEventApi: `${BASE_URL}booking/list/past`,
  getUpcomingEventApi: `${BASE_URL}booking/list/upcoming`,
  getUpcomingEventDashboardApi: `${BASE_URL}booking/list/upcoming/starttime`,
  getEventDetailApi: `${BASE_URL}booking/getbooking`,
  getAvailableBartendersApi: `${BASE_URL}booking/availablebartender`,
  updateBookingBartendersApi : `${BASE_URL}booking/changebookingbartender`,
  addEventNoteApi : `${BASE_URL}booking/addnote`,
  getEventNotesApi : `${BASE_URL}booking/getnote`,
  deleteEventNodeApi : `${BASE_URL}booking/deletenote`,
  updateEventNoteApi : `${BASE_URL}booking/updatenote`,

// Package 

  packageDefaultSupplies : `${BASE_URL}packages/defaultsupply`,

  // notification
  notificaitonListApi : `${BASE_URL}notifications`,
  notificaitonCountApi : `${BASE_URL}notifications/notificationcount`,
  markAsReadNotificationApi : `${BASE_URL}notifications`,

  // upload video
  bsnsUploadVid : `${BASE_URL}business/video`,
  bsnsDeleteVid : `${BASE_URL}business/video`,
  // upload image
  bsnsUploadImg : `${BASE_URL}business/image`,
  bsnsDeleteImg : `${BASE_URL}business/image`,
  // Upload File
  uploadFileApi: `${BASE_URL}upload/file`,
  deleteFileApi: `${BASE_URL}upload/file`,
  //Dashboard
  //Revenue Api
  getRevenueApi :`${BASE_URL}revenue`,
  getRevnuePackage :`${BASE_URL}revenue/packages`,
  //Chart
  getChartRevenue:`${BASE_URL}revenue/chart`,
  // payments
  getPaymentsApi : `${BASE_URL}payments`,
  postPaymentApi : `${BASE_URL}payments`,
  getBookingTransactionApi: `${BASE_URL}payments`,
  // Stripe and subscription
  setUpIntent:`${BASE_URL}billing/create-setup-intent`,
  savePaymentMethod:`${BASE_URL}billing/addcard`,
  // getCardInfoApi:`${BASE_URL}billing/card`,
  getProductDetailApi:`${BASE_URL}billing/product`,
  billingHistoryApi:`${BASE_URL}billing/history`,
  billingDetailsApi:`${BASE_URL}billing/billingdetail`,
  cancelSubscriptionApi:`${BASE_URL}billing/cancel-subscription`,
  subscriptApi:`${BASE_URL}billing/restart-subscription`,
  pendingInvoicesApi:`${BASE_URL}billing/pending-invoices`,
}



